module.exports = __webpack_public_path__ + "static/media/prv4.c82c3f0c.jpg";